import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

const Button = styled.button`
  font: inherit;
  color: inherit;
  text-align: left;
  appearance: none;
  background-color: transparent;
  border: none;
  position: relative;
  padding: 0 0 0 50px;
  line-height: 24px;
  top: 0px;
  height: auto;
  margin: 0px;
  opacity: ${props => (props.selected ? 1 : 0.8)};
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid ${({ color }) => color || theme.colors.neutral[800]};
    top: 0px;
    left: 0px;
  }

  &:after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${({ selected, color }) =>
      selected ? color || theme.colors.neutral[800] : 'transparent'};
    top: 3px;
    left: 3px;
  }
`;

const RadioButton = ({
  children,
  className,
  dataFrom,
  dataClick,
  onClick,
  selected,
  testId,
  color,
}) => (
  <Button
    className={className}
    color={color}
    data-click={dataClick}
    data-from={dataFrom}
    data-testid={`${testId}-${selected ? 'selected' : `not-selected`}`}
    onClick={onClick}
    selected={selected}
    type="button"
  >
    {children}
  </Button>
);

RadioButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  dataClick: PropTypes.string,
  dataFrom: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  testId: PropTypes.string,
};

RadioButton.defaultProps = {
  className: null,
  dataClick: 'select',
  dataFrom: 'radio-button',
  testId: 'radio-button',
  color: null,
};

export default RadioButton;
